// Shona translations
export const sn: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Vatengi',
  'menu.products': 'Zvigadzirwa',
  'menu.users': 'Vashandisi',
  'menu.settings': 'Maitiro',
  'menu.logout': 'Buda',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Murayiro Mutsva',
  'order.title': 'Murayiro Mutsva',
  'order.customer': 'Mutengi',
  'order.products': 'Zvigadzirwa',
  'order.total': 'Zvose',
  'users.title': 'Vashandisi',
  'users.name': 'Zita',
  'users.email': 'Imelo',
  'common.yes': 'Ehe',
  'common.no': 'Kwete',
  'common.cancel': 'Kanzura',
  'common.save': 'Chengetedza',
  'common.search': 'Tsvaga',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Pinda',
  'login.welcome': 'Mauya, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Imelo',
  'signup.phone': 'Runhare',
  'menu.reportsAndAccounting': 'Mishumo neKuverenga Mari',
  'menu.systemAndCommunication': 'Sisitimu neKukurukurirana',
};